import React, { useEffect } from "react";
import { app, pages } from "@microsoft/teams-js";

const RemoveTab = () => {
  useEffect(() => {
    const init = async () => {
      try {
        await app.initialize();
        console.log("Teams SDK initialized (Remove)");

        // Notify Teams that tab removal is acknowledged
        pages.config.registerOnRemoveHandler((removeEvent) => {
          console.log("Tab remove event triggered");
          removeEvent.notifySuccess(); 
        });

      } catch (err) {
        console.error("Teams SDK init failed on remove:", err);
      }
    };

    init();
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h3>Givent tab removed</h3>
      <p>You can close this window.</p>
    </div>
  );
};

export default RemoveTab;
